import { jsx as e, jsxs as d } from "react/jsx-runtime";
import o from "./index26.js";
const f = ({
  className: i,
  title: r,
  content: s,
  type: p
}) => /* @__PURE__ */ e(
  "div",
  {
    "data-type": p,
    className: `form-message${i ? " " + i : ""}`,
    children: /* @__PURE__ */ d("div", { children: [
      /* @__PURE__ */ e("h6", { children: typeof r == "string" ? o(r) : r }),
      /* @__PURE__ */ e("p", { children: typeof s == "string" ? o(s) : s })
    ] })
  }
);
export {
  f as FormMessages
};
